import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  container: {
    paddingVertical: 32,
    paddingHorizontal: 42,
    flex: 1,
  },
  innerContainer: {
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  textIconContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  cancelButtonText: {
    fontWeight: 'normal',
  },
  iconBubble: {
    width: 80,
    height: 80,
    borderRadius: 40,
    alignItems: 'center',
    justifyContent: 'center',
  },
  closeButtonContainer: {
    alignItems: 'flex-end',
  },
});
